/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlayerTeamAssignmentRequest
 */
export interface PlayerTeamAssignmentRequest {
    /**
     * ID of the team to assign the player to
     * @type {string}
     * @memberof PlayerTeamAssignmentRequest
     */
    teamId: string;
    /**
     * Jersey/player number for this team
     * @type {number}
     * @memberof PlayerTeamAssignmentRequest
     */
    playerNumber?: number;
}

/**
 * Check if a given object implements the PlayerTeamAssignmentRequest interface.
 */
export function instanceOfPlayerTeamAssignmentRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "teamId" in value;

    return isInstance;
}

export function PlayerTeamAssignmentRequestFromJSON(json: any): PlayerTeamAssignmentRequest {
    return PlayerTeamAssignmentRequestFromJSONTyped(json, false);
}

export function PlayerTeamAssignmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerTeamAssignmentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'teamId': json['teamId'],
        'playerNumber': !exists(json, 'playerNumber') ? undefined : json['playerNumber'],
    };
}

export function PlayerTeamAssignmentRequestToJSON(value?: PlayerTeamAssignmentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'teamId': value.teamId,
        'playerNumber': value.playerNumber,
    };
}

